import styled from 'styled-components';
import { GapProps, PaddingProps, SizeProps } from '@/types/ui';
import { getPaddingStyle, getSizeStyle } from '@/utils/style/ui';

export interface Props {
  $template?: string;
  $templateAreas?: string;
  $templateRows?: string;
  $templateColumns?: string;
  $gap?: GapProps;
  $width?: SizeProps;
  $height?: SizeProps;
  $minWidth?: SizeProps;
  $minHeight?: SizeProps;
  $maxWidth?: SizeProps;
  $maxHeight?: SizeProps;
  $padding?: PaddingProps | number | { x: number; y: number };
}

const Grid = styled.div<Props>`
  display: grid;
  ${({ $template }) => ($template ? `grid-template: ${$template};` : '')}
  ${({ $templateAreas }) =>
    $templateAreas ? `grid-template-areas: ${$templateAreas};` : ''}
  ${({ $templateRows }) =>
    $templateRows ? `grid-template-rows: ${$templateRows};` : ''}
  ${({ $templateColumns }) =>
    $templateColumns ? `grid-template-columns: ${$templateColumns};` : ''}
  ${({ theme, $gap }) => getSizeStyle({ theme, size: $gap, key: 'gap' })}
  ${({ theme, $width }) => getSizeStyle({ theme, size: $width, key: 'width' })};
  ${({ theme, $minWidth }) =>
    getSizeStyle({ theme, size: $minWidth, key: 'min-width' })};
  ${({ theme, $maxWidth }) =>
    getSizeStyle({ theme, size: $maxWidth, key: 'max-width' })};
  ${({ theme, $height }) =>
    getSizeStyle({ theme, size: $height, key: 'height' })};
  ${({ theme, $minHeight }) =>
    getSizeStyle({ theme, size: $minHeight, key: 'min-height' })};
  ${({ theme, $maxHeight }) =>
    getSizeStyle({ theme, size: $maxHeight, key: 'max-height' })};
  ${({ theme, $padding }) =>
    getPaddingStyle({ theme, padding: $padding, defaultValue: 'zero' })}
`;

export default Grid;
